import { Suspense, useEffect } from "react";
import { ThemeProvider } from "@mui/material";
import { RouterProvider } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { useMode } from "./assets/theme";
import { router } from "./routes";
import { SnackbarProvider } from "./components/snackbar/snackbarContext";
import { AuthProvider } from "./auth/authContext";
import { initGA, logPageView } from "./utils/analytics";

const App = () => {
  const theme = useMode();

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 0,
      },
    },
  });

  useEffect(() => {
    initGA();
    logPageView();
  }, []);

  useEffect(() => {
    logPageView(location?.pathname);
  }, [location?.pathname]);

  return (
    <QueryClientProvider client={queryClient}>
      <Suspense fallback={<div>Loading...</div>}>
        <AuthProvider>
          <SnackbarProvider>
            <ThemeProvider theme={theme}>
              <RouterProvider router={router} />
            </ThemeProvider>
          </SnackbarProvider>
        </AuthProvider>
      </Suspense>
    </QueryClientProvider>
  );
};
export default App;
